export enum MenuItems {
  LanguageSelector = 'LanguageSelector',
  Search = 'Search',
}
